import {IFlatInvestmentBoosterParams} from "../types/booster_generic/IFlatInvestmentBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {flatInvestmentAreaBooster} from "./flat_investment/flat_investment_area_booster";
import {flatInvestmentBalconyBooster} from "./flat_investment/flat_investment_balcony_booster";
import {flatInvestmentBDViewsLast3daysBooster} from "./flat_investment/flat_investment_bd_views_last_3days_booster";
import {flatInvestmentFloorBooster} from "./flat_investment/flat_investment_floor_booster";
import {flatInvestmentGarageBooster} from "./flat_investment/flat_investment_garage_booster";
import {flatInvestmentRoomBooster} from "./flat_investment/flat_investment_room_booster";
import {flatInvestmentTerraceBooster} from "./flat_investment/flat_investment_terrace_booster";
import {promotionDiscountBooster} from "./promotions/promotion_discount_booster";
import {promotionExhibitionBooster} from "./promotions/promotion_exhibition_booster";
import {promotionLastMinuteBooster} from "./promotions/promotion_last_minute_booster";
import {promotionNoContributionBooster} from "./promotions/promotion_no_contribution_booster";
import {promotionOpenDaysBooster} from "./promotions/promotion_open_days_booster";
import {promotionPresaleBooster} from "./promotions/promotion_presale_booster";
import {promotionPromotionBooster} from "./promotions/promotion_promotion_booster";

export const flatInvestmentBoostersConfig: IGenericBoostersConfig<IFlatInvestmentBoosterParams> = {
    [IBoosterCategory.Promotion]: {
        [promotionPromotionBooster.type]: promotionPromotionBooster,
        [promotionOpenDaysBooster.type]: promotionOpenDaysBooster,
        [promotionDiscountBooster.type]: promotionDiscountBooster,
        [promotionLastMinuteBooster.type]: promotionLastMinuteBooster,
        [promotionPresaleBooster.type]: promotionPresaleBooster,
        [promotionExhibitionBooster.type]: promotionExhibitionBooster,
        [promotionNoContributionBooster.type]: promotionNoContributionBooster
    },
    [IBoosterCategory.OfferStats]: {
        [flatInvestmentAreaBooster.type]: flatInvestmentAreaBooster,
        [flatInvestmentRoomBooster.type]: flatInvestmentRoomBooster,
        [flatInvestmentGarageBooster.type]: flatInvestmentGarageBooster,
        [flatInvestmentFloorBooster.type]: flatInvestmentFloorBooster,
        [flatInvestmentTerraceBooster.type]: flatInvestmentTerraceBooster,
        [flatInvestmentBalconyBooster.type]: flatInvestmentBalconyBooster
    },
    [IBoosterCategory.BigDataStats]: {
        [flatInvestmentBDViewsLast3daysBooster.type]: flatInvestmentBDViewsLast3daysBooster
    }
};
import {IFlatInvestmentBoosterParams} from "../types/booster_generic/IFlatInvestmentBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {flatInvestmentAreaBooster} from "./flat_investment/flat_investment_area_booster";
import {flatInvestmentBalconyBooster} from "./flat_investment/flat_investment_balcony_booster";
import {flatInvestmentBDViewsLast3daysBooster} from "./flat_investment/flat_investment_bd_views_last_3days_booster";
import {flatInvestmentFloorBooster} from "./flat_investment/flat_investment_floor_booster";
import {flatInvestmentGarageBooster} from "./flat_investment/flat_investment_garage_booster";
import {flatInvestmentRoomBooster} from "./flat_investment/flat_investment_room_booster";
import {flatInvestmentTerraceBooster} from "./flat_investment/flat_investment_terrace_booster";
import {promotionDiscountBooster} from "./promotions/promotion_discount_booster";
import {promotionExhibitionBooster} from "./promotions/promotion_exhibition_booster";
import {promotionLastMinuteBooster} from "./promotions/promotion_last_minute_booster";
import {promotionNoContributionBooster} from "./promotions/promotion_no_contribution_booster";
import {promotionOpenDaysBooster} from "./promotions/promotion_open_days_booster";
import {promotionPresaleBooster} from "./promotions/promotion_presale_booster";
import {promotionPromotionBooster} from "./promotions/promotion_promotion_booster";

export const flatInvestmentBoostersConfig: IGenericBoostersConfig<IFlatInvestmentBoosterParams> = {
    [IBoosterCategory.Promotion]: {
        [promotionPromotionBooster.type]: promotionPromotionBooster,
        [promotionOpenDaysBooster.type]: promotionOpenDaysBooster,
        [promotionDiscountBooster.type]: promotionDiscountBooster,
        [promotionLastMinuteBooster.type]: promotionLastMinuteBooster,
        [promotionPresaleBooster.type]: promotionPresaleBooster,
        [promotionExhibitionBooster.type]: promotionExhibitionBooster,
        [promotionNoContributionBooster.type]: promotionNoContributionBooster
    },
    [IBoosterCategory.OfferStats]: {
        [flatInvestmentAreaBooster.type]: flatInvestmentAreaBooster,
        [flatInvestmentRoomBooster.type]: flatInvestmentRoomBooster,
        [flatInvestmentGarageBooster.type]: flatInvestmentGarageBooster,
        [flatInvestmentFloorBooster.type]: flatInvestmentFloorBooster,
        [flatInvestmentTerraceBooster.type]: flatInvestmentTerraceBooster,
        [flatInvestmentBalconyBooster.type]: flatInvestmentBalconyBooster
    },
    [IBoosterCategory.BigDataStats]: {
        [flatInvestmentBDViewsLast3daysBooster.type]: flatInvestmentBDViewsLast3daysBooster
    }
};
